export default {"src":"/_next/static/media/join-tiktok-v3.99194552.svg","height":24,"width":22,"blurWidth":0,"blurHeight":0};